module.exports = __webpack_public_path__ + "img/home_small.33f0073a.svg";